$(document).ready(function(){
  //console.log("documenttt>>>",document.readyState);
  $('.quick-add__submit').attr('disabled',true)
    var btn = $('.back_to_top_custom');

$(window).scroll(function() {
  if ($(window).scrollTop() > 850) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:-10}, '550');
  // console.log("document.documentElement.scrollTop>>",document.documentElement.scrollTop)
  document.documentElement.scrollTop = -10;
});
})
$(window).on('load',function(){
  // console.log("documentuuu>>>",$('.quick-add__submit'));
  if(document.readyState == "complete"){
    $('.quick-add__submit').removeAttr('disabled')

  }
})
$.fn.isInViewport = function() { var elementTop=$(this).offset().top,elementBottom=elementTop + $(this).outerHeight(),viewportTop=$(window).scrollTop(),viewportBottom=viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
}



$(document).on("click","span.stamped-badge",function() {
    var header_height = $("div#shopify-section-header").height();
    $('html, body').animate({
        scrollTop: $("div#stamped-main-widget").offset().top - header_height
    }, 2000);
  });
  $(document).on("click", "li.menu_all_rpeat", function() {
    $(".menu_all_rpeat").removeClass("highlight_menu");
    $(this).addClass("highlight_menu");
  });
  $(document).on("click", ".back_button_main", function() {
    $("ul.menu-drawer__menu.has-submenu.list-menu.submenu-open details.menu-opening button.menu-drawer__close-button.link.link--text.focus-inset").trigger("click");
    $(".menu_all_rpeat").removeClass("highlight_menu");
  });
  
  
  
  $(document).on("click", ".new_custom_addtoart", function() {
    var productid = $(this).parents(".product-form").find(".get_cust_id").val();
    var get_qty = $(this).parents(".custom-atc-wrapp").find(".quantity_input_product").val();
  //   var productid = parseInt($(this).parents(".product-form").find(".get_cust_id").val());
  // var get_qty = parseInt($(this).parents(".custom-atc-wrapp").find(".quantity_input_product").val()) || 1;
  
  console.log("Variant ID:", productid);
  console.log("Quantity:", get_qty);
  
  if (!productid || isNaN(productid)) {
    console.error("Invalid variant ID");
    return;
  }
  if (!get_qty || isNaN(get_qty) || parseInt(get_qty) <= 0) {
    get_qty = 1;
  }
  
    $(this).addClass("animated_btn");
  
    var thisitem = $(this)
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({
        id: parseInt(productid),
        quantity: parseInt(get_qty)
      }),
        success: function(gethtml) {
            jQuery.ajax({
                type: 'GET',
                url: gethtml.url,
                dataType: 'json',
                success: function(productdata) {
                    var get_category = $(thisitem).attr("data-category");
                    let variant_name = '';
                    for (let i = 0; i < productdata.product.variants.length; i++) {
                        variant_name += productdata.product.variants[i].title + ',';
                    }
                    const new_var_name = variant_name.slice(0, -1).trim();
                    for (let i = 0; i < productdata.product.variants.length; i++) {
                        if (gethtml.variant_id == productdata.product.variants[i].id) {
                            const main_price = parseInt(productdata.product.variants[i].price);
                            const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
                            let discount_exist = 'NA';
                            if (compare_main_price > main_price) {
                                discount_exist = compare_main_price - main_price;
                            }
                            var variant_string_id = productdata.product.variants[i].id.toString();
                            const itemData = {
                                item_id: productdata.product.variants[i].sku,
                                item_name: gethtml.title,
                                coupon: "NA",
                                discount: discount_exist,
                                item_brand: "Re'equil",
  
                                item_category: productdata.product.product_type,
                                item_category2: get_category,
                                item_list_id: "N/A", //productdata.product.id,
                                item_list_name: "N/A", // productdata.product.variants[i].title,
                                item_variant: new_var_name == "Default Title" ? "NA" : new_var_name,
                                price: main_price,
                                quantity: parseInt(get_qty)
                            };
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            window.dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    currency: "INR",
                                    value: main_price,
                                    items: [itemData],
                                },
                            });
  
  
                        }
                    }
  
                },
            });
  
            jQuery.getJSON('/cart.js', function(cart) {
                const cart_tottal_price = cart.total_price / 100
                var jsonObj = [];
                var requests = cart.items.map(function(item) {
                    return jQuery.ajax({
                        type: 'GET',
                        url: item.url,
                        dataType: 'json'
                    }).then(function(productdata) {
                        var data_category = $(".cart-item[item_id='" + productdata.product.id + "']").attr("data-category");
                        let variant_name = '';
                        for (let i = 0; i < productdata.product.variants.length; i++) {
                            variant_name += productdata.product.variants[i].title + ',';
                        }
                        const new_var_name = variant_name.slice(0, -1).trim();
                        for (let i = 0; i < productdata.product.variants.length; i++) {
                            if (item.variant_id == productdata.product.variants[i].id) {
                                const main_price = parseInt(productdata.product.variants[i].price);
                                const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
                                let discount_exist = 'NA';
                                if (compare_main_price > main_price) {
                                    discount_exist = compare_main_price - main_price;
                                }
                                var variant_string_id = productdata.product.variants[i].id.toString();
  
  
                                return {
                                    item_id: productdata.product.variants[0].sku,
                                    item_name: item.title,
                                    coupon: "NA",
                                    discount: discount_exist,
                                    item_brand: "Re'equil",
  
                                    item_category: productdata.product.product_type,
                                    item_category2: data_category,
                                    item_list_id: variant_string_id,
                                    item_list_name: productdata.product.title,
                                    item_variant: new_var_name == "Default Title" ? "NA" : new_var_name,
                                    price: main_price,
                                    quantity: item.quantity
                                };
  
                            }
                        }
  
  
                    });
                });
                jQuery.when.apply(jQuery, requests).done(function() {
                    Array.prototype.forEach.call(arguments, function(result) {
                        jsonObj = jsonObj.concat(result);
                    });
  
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        ecommerce: null
                    }); // Clear the previous ecommerce object.
                    window.dataLayer.push({
                        event: "view_cart ",
                        ecommerce: {
                            currency: "INR",
                            value: cart_tottal_price,
                            items: jsonObj,
                        },
                    });
                });
            });
  
  
  
            jQuery.ajax({
                type: 'GET',
                url: '/cart',
                dataType: 'html',
                success: function(cart) {
                    $(thisitem).removeClass("animated_btn");
                    if ($(".UpsellWrapperCard").hasClass("active")) {} else {
                        setTimeout(function() {
                            $(".UpsellWrapperCard").removeClass("active");
                        }, 800);
  
                    }
                    fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                        const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                        const bubble = document.querySelector('#cart-icon-bubble');
                        bubble.innerHTML = bubbleHTML;
                    })
                    fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                        const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                        const drawer = document.querySelector('cart-drawer');
                        drawer.innerHTML = newHTML;
                    });
                    $(".RQCartDRawerExecutionmWp ").removeClass("is-empty");
                    $(".RQCartDRawerExecutionmWp ").addClass("active");
  
                    snaptr('track', 'ADD_CART');
                    setTimeout(function() {
                        if (document.querySelectorAll('.new_custom_drawer_products').length > 0) {
                            function FounderCookie(cookieName) {
                                const cookies = document.cookie.split(';');
                                for (let i = 0; i < cookies.length; i++) {
                                    const cookie = cookies[i].trim();
                                    if (cookie.startsWith(cookieName + '=')) {
                                        return true;
                                    }
                                }
                                return false;
                            }
  
                            function startTimer(duration, display) {
                                var timer = duration,
                                    minutes, seconds;
                                setInterval(function() {
                                    minutes = parseInt(timer / 60, 10)
                                    seconds = parseInt(timer % 60, 10);
                                    // minutes = minutes < 10 ? "0" + minutes : minutes;
                                    // seconds = seconds < 10 ? "0" + seconds : seconds;
  
                                    var minutes_fst = minutes.toString().split("").map(Number)[0];
                                    var minutes_scd = minutes.toString().split("").map(Number)[1];
  
                                    var seconds_fst = seconds.toString().split("").map(Number)[0];
                                    var seconds_scd = seconds.toString().split("").map(Number)[1];
  
                                    if (typeof minutes_scd !== 'undefined') {
                                        display.querySelector('#timer-hours').innerHTML = `<span>${minutes_fst}</span><span>${minutes_scd}</span>`;
                                    } else {
                                        display.querySelector('#timer-hours').innerHTML = `<span>0</span><span>${minutes_fst}</span>`;
                                    }
  
                                    if (typeof seconds_scd !== 'undefined') {
                                        display.querySelector('#timer-minutes').innerHTML = `<span>${seconds_fst}</span><span>${seconds_scd}</span>`;
                                    } else {
                                        display.querySelector('#timer-minutes').innerHTML = `<span>0</span><span>${seconds_fst}</span>`;
                                    }
  
  
                                    if (FounderCookie('offerInvalid')) {} else {
                                        if (--timer < 0) {
                                            const expirationDate = new Date();
                                            expirationDate.setDate(expirationDate.getDate() + 7);
                                            document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
                                        }
                                    }
  
                                    if (FounderCookie('offerInvalid')) {
                                        if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                                        }
                                        if (document.querySelector('.new_custom_drawer_products')) {
                                            document.querySelector('.new_custom_drawer_products').style.display = 'none';
                                        }
                                        window.localStorage.removeItem("seconds")
                                        window.localStorage.removeItem("minutes")
                                    } else {
                                        if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                                        }
                                        if (document.querySelector('.new_custom_drawer_products')) {
                                            document.querySelector('.new_custom_drawer_products').style.display = 'block';
                                        }
                                        window.localStorage.setItem("seconds", seconds)
                                        window.localStorage.setItem("minutes", minutes)
                                    }
  
  
  
  
                                }, 1000);
                            }
  
                            var sec = parseInt(window.localStorage.getItem("seconds"));
                            var min = parseInt(window.localStorage.getItem("minutes"));
  
                            if (FounderCookie('offerInvalid')) {
                                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                                }
                                if (document.querySelector('.new_custom_drawer_products')) {
                                    document.querySelector('.new_custom_drawer_products').style.display = 'none';
                                }
                                window.localStorage.removeItem("seconds")
                                window.localStorage.removeItem("minutes")
                            } else {
                                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                                }
                                if (document.querySelector('.new_custom_drawer_products')) {
                                    document.querySelector('.new_custom_drawer_products').style.display = 'block';
                                }
                            }
  
                            if (parseInt(min * sec)) {
                                var fiveMinutes = (parseInt(min * 60) + sec);
                            } else {
                                var fiveMinutes = 60 * 30;
                            }
  
                            var display = document.querySelector('#timer-box');
                            if (parseInt(min) == 0) {
                                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                                }
                                if (document.querySelector('.new_custom_drawer_products')) {
                                    document.querySelector('.new_custom_drawer_products').style.display = 'none';
                                }
                                window.localStorage.removeItem("seconds")
                                window.localStorage.removeItem("minutes")
                                const expirationDate = new Date();
                                expirationDate.setDate(expirationDate.getDate() + 7);
                                document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
                            } else {
                                startTimer(fiveMinutes, display);
                            }
  
                        } else {
                            document.querySelector('.drawer_timer_outer-wrapp').classList.add('hidden');
                        }
  
                    }, 800);
                    setTimeout(function() {
                        Smile.ready().then(smileInstance => {
                            $(".int_discount_text span.sweettooth-points-balance").html(smileInstance.customer.points_balance);
                        }).catch(err => {
                            // An error has occurred will initializing smile.
                        });
                    }, 2000);
                },
            });
        },
    });
  });
  
  $(window).on('resize scroll', function() {
    $(".custom_new-sec-wrapper").each(function() {
        jsonObj = [];
        $(this).find(".custom_image_pdp_sec .swiper-slide").each(function() {
            var get_height = $(this).find(".side_content").height();
            jsonObj.push(parseInt(get_height));
        });
        const max = jsonObj.reduce((a, b) => Math.max(a, b), -Infinity);
        $(this).find(".slider__controls").css("bottom", max)
    });
    if ($(window).width() < 749) {
        var scrollAtc = $(window).scrollTop();
        if (scrollAtc >= 130) {
            $(".MainCombineSwatchProductInt").addClass("show_me_now");
        }
        $('.RQ-productBestPairedMn, product-recommendations').each(function() {
            const viewportChecker = $(this).isInViewport() ? $('.MainCombineSwatchProductInt').removeClass("show_me_now") : $('.MainCombineSwatchProductInt').addClass("show_me_now");
        });
        if (scrollAtc < 130) {
            $(".MainCombineSwatchProductInt").removeClass("show_me_now");
        }
    }
  });
  
  // $(document).on('click','.rvm_container',function(e){e.preventDefault();
  //   var videoConnect=$(this).children('.rvm_vid_make').children('.videoJSHANDLE');
  //   const pauseChecker = videoConnect.get(0).paused ? 
  //     ($(this).children('.playPauseInit').addClass('hidden'),$(this).children('.playPauseInit').children('.soundMuteSure').removeClass('hidden').siblings('.soundUnmuteSure').addClass('hidden'),videoConnect.get(0).play()) :
  //     ($(this).children('.playPauseInit').removeClass('hidden'),$(this).children('.playPauseInit').children('.soundMuteSure').addClass('hidden').siblings('.soundUnmuteSure').removeClass('hidden'),videoConnect.get(0).pause());
  // })
  // $(document).on('mousemove','.rvm_container',function(e){ if(!$(e.target).closest('.playPauseInit').length > 0){ $(this).children('.playPauseInit').removeClass('hidden'); } })
  // $(document).on('mouseenter','.rvm_container',function(e){ if(!$(e.target).closest('.playPauseInit').length > 0){ $(this).siblings('.playPauseInit').removeClass('hidden'); } })
  // $(document).on('mouseleave','.rvm_container',function(e){ var videoConnect=$(this).children('.rvm_vid_make').children('.videoJSHANDLE');
  //   const miskRise= (!$(e.target).closest('.playPauseInit').length > 0, videoConnect.get(0).paused) ? $(this).children('.playPauseInit').removeClass('hidden') : $(this).children('.playPauseInit').addClass('hidden');
  // })
  // $(window).on("load",function() {
  //   $("body").addClass("shipping_icon_animate");
  //   setTimeout(function() {
  //      $("body").addClass("shipping_text_show");
  //   },5000);
  
  // });
  // $(window).on("load",function() {
  // setTimeout(function() {    
  //    $(".new-launch-animated_gif_image").hide();
  // },4000);
  //    });
  $(window).on("load", function() {
    var getcontent = getCookie('accordion_close');
    if (getcontent == 'yes') {
        $(".drawer__footer .GiftRewardsWrapper.UpsellWrapperCard").removeClass("active");
    } else {
        $(".drawer__footer .GiftRewardsWrapper.UpsellWrapperCard").addClass("active");
    }
  });
  $(document).ready(function() {
  
    if ($(window).width() < 750) {
        if (window.location.href.indexOf("#raise-ticket") > -1) {
            var header_height = $(".header-wrapper").height();
            $('html, body').animate({
                scrollTop: $(".rasise_ticker_sec").offset().top - header_height
            }, 2000);
        }
    }
  
  });
  document.addEventListener('DOMContentLoaded', function() {
  
  
    $(".custom_new-sec-wrapper").each(function() {
        jsonObj = [];
        $(this).find(".custom_image_pdp_sec .swiper-slide").each(function() {
            var get_height = $(this).find(".side_content").height();
            jsonObj.push(parseInt(get_height));
        });
        const max = jsonObj.reduce((a, b) => Math.max(a, b), -Infinity);
        $(this).find(".slider__controls").css("bottom", max)
    });
    $(document).on("change", ".new-cc-tesmp-main .qty_class .quantity__input", function() {
        var get_value = $(this).val();
        $(this).parents(".qty_class").find(".quantity__input").val(get_value);
    });
  
    $(document).on("change", ".custom-new-temp-wrapp .qty_class .quantity__input", function() {
        var get_value = $(this).val();
        $(this).parents(".qty_class").find(".quantity__input").val(get_value);
    });
  
    $(".new-article-content_wrapp .article-template__content h2").each(function() {
        var data_text = $(this).html();
        var data_text2 = data_text.replace("<br>", " ");
        var data_text3 = data_text2.replace("'", "");
        var remove_break = data_text3.replace(/(<([^>]+)>)/gi, "");
        var final_data_value = remove_break.replace("&nbsp;", "");
        var without_space = $.trim(final_data_value);
        $(this).attr("data-handle", without_space);
    });
    //Handle Pincode Checking
    var submitButton = document.getElementById('submitButton');
    if (!submitButton) {
        console.warn('Button not found');
    } else {
        submitButton.addEventListener('click', function() {
            var inputField = document.getElementById('PostalCode');
            var inputValue = inputField.value;
            var obj = this;
            var buttonText = obj.querySelector('span');
            var errorMessage = document.querySelector('.ErrorMessage'); // Select the error message element
  
            // Toggle behavior based on the button text
            if (buttonText.innerHTML === 'change') {
                // Allow editing and reset button to 'check'
                inputField.readOnly = false; // Make the input field editable
                inputField.value = ''; // Clear the input field
                buttonText.innerHTML = 'check'; // Change text to 'check'
                var datOuterDiv = document.querySelector('.DatOuterDiv');
                datOuterDiv.style.display = 'none'; // Hide additional divs when clearing the input
                var nodelivery = document.querySelector('.Nodelivery');
                nodelivery.style.display = 'none'; // Hide the delivery message
                if (errorMessage) errorMessage.style.display = 'none'; // Hide error message
                return;
            }
  
            // Check if the input field is empty
            if (inputValue.trim() === '') {
                // Display error message
                if (errorMessage) {
                    errorMessage.style.display = 'block';
                    errorMessage.innerHTML = 'Please enter pincode.';
                }
                return; // Stop further execution if input is empty
            } else {
                // Hide error message if input is not empty
                if (errorMessage) errorMessage.style.display = 'none';
            }
  
            // Proceed with delivery check if input field is not empty
            buttonText.classList.add('hidden');
            obj.querySelector('.loading-overlay__spinner').classList.add('loading');
            obj.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  
            var url = '/pages/pincod'; // Replace with your actual URL
  
            fetch(url)
                .then(function(response) {
                    return response.text();
                })
                .then(function(data) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(data, 'text/html');
                    var options = doc.querySelectorAll("#PinCodSelect option");
                    var matchFound = false,
                        secondMatch = '';
  
                    options.forEach(function(option) {
                        var optionFirstPValue = option.getAttribute('firstP');
                        buttonText.classList.remove('hidden');
                        obj.querySelector('.loading-overlay__spinner').classList.remove('loading');
                        obj.querySelector('.loading-overlay__spinner').classList.add('hidden');
  
                        if (optionFirstPValue === inputValue) {
                            secondMatch = option.getAttribute('lastP');
                            matchFound = true;
                            return;
                        }
                    });
  
                    var onDelivery = document.querySelector('.Ondelivery');
  
                    if (matchFound) {
                        if (secondMatch.trim() === 'TRUE') {
                            document.querySelector('.CustomAddition').innerHTML = 'Cash on delivery available on orders above ₹299';
                            var datOuterDiv = document.querySelector('.DatOuterDiv');
                            datOuterDiv.style.display = 'block';
                            var nodelivery = document.querySelector('.Nodelivery');
                            nodelivery.style.display = 'none';
                            buttonText.innerHTML = 'change';
                            inputField.readOnly = true; // Make the input field read-only again
                            var product_title = $(".product__title h1").text();
                            var trimmed_title = $.trim(product_title);
                            dataLayer.push({
                                'event': 'delivery_check',
                                'pincode': inputValue,
                                'product_title': trimmed_title
                            });
                        } else {
                            var datOuterDiv = document.querySelector('.DatOuterDiv');
                            datOuterDiv.style.display = 'block';
                            var onDelivery = document.querySelector('.Ondelivery');
                            document.querySelector('.CustomAddition').innerHTML = 'Cash on delivery not Available';
                            var nodelivery = document.querySelector('.Nodelivery');
                            nodelivery.style.display = 'none';
                            buttonText.innerHTML = 'change';
                            inputField.readOnly = true; // Make the input field read-only again
                        }
                    } else {
                        var nodelivery = document.querySelector('.Nodelivery');
                        if (inputValue.length < 6) {
                            // Display the error message
                            nodelivery.style.display = 'block';
                            nodelivery.innerHTML = 'Invalid pincode. Please try again.';
                            buttonText.innerHTML = 'change';
                            inputField.readOnly = true; // Make the input field read-only again
                        } else {
                            nodelivery.style.display = 'block';
                            nodelivery.innerHTML = 'Sorry, we do not deliver at this location. Try another PIN code.';
                            buttonText.innerHTML = 'change';
                            inputField.readOnly = true; // Make the input field read-only again
                        }
                        var datOuterDiv = document.querySelector('.DatOuterDiv');
                        datOuterDiv.style.display = 'none';
                    }
                })
                .catch(function(error) {
                    console.error(error);
                });
        });
    }
  
    var swiper = new Swiper(".product__accordion_custom .custom_accordian_product_slider", {
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: {
            nextEl: ".NextButtonSlideshowfd",
            prevEl: ".PrevButtonSlideShowfd"
        },
        pagination: {
            el: ".paginationFractionWp",
            clickable: true,
            dynamicBullets: true
        },
        breakpoints: {
            640: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                pagination: {
                    el: ".paginationFractionWp",
                    type: "fraction"
                }
            },
            768: {
                slidesPerView: 3.4,
                spaceBetween: 16,
                pagination: {
                    el: ".paginationFractionWp",
                    type: "fraction"
                }
            },
            1024: {
                slidesPerView: 3.4,
                spaceBetween: 24,
                pagination: {
                    el: ".paginationFractionWp",
                    type: "fraction"
                }
            }
        },
        on: {
            slideChange: function(swiper, event) {
                var direction = swiper.realIndex > swiper.previousIndex ? 'left' : 'right';
                var get_resigm_tab = $(".innner_tabs_rpeater h2.activeTab").text();
                var image_position = parseInt(swiper.previousIndex) + 1
                dataLayer.push({
                    'event': 'product_card_swipe',
                    'page_section': "Product",
                    'swipe_direction': direction,
                    'image_position': image_position,
                    'regime_step': get_resigm_tab
                });
            }
        }
    });
    if ($(window).width() < 750) {
        $(".new-article_main-wrapper .article-template__content p").each(function() {
            var peragraph_html = $(this).html();
            if (peragraph_html.indexOf("iframe") > -1) {
                $(this).css("padding", "0")
            }
        });
    }
  
    $(".CollProGridItem").each(function() {
        var sizze_length = $(this).find(".allvarinat_wrapper .input_label_wrapper:hidden").length;
        if (sizze_length > 0) {
            $(this).find(".hidden_size_val").html("<p>+" + sizze_length + " more</p>");
        }
  
    });
    $(document).on("change", ".input_label_wrapper input", function() {
        var variant_price = $(this).attr("var-price");
        $(this).parents(".card-information").find(".price__regular .price-item--regular").html(variant_price);
    });
    // $(".product__accordion_custom .accordion__content.rte button.quick-add__submit").click(function() {
    //   $(this).parents(".product__accordion_custom").find(".already_selected_message").show();
    //      $(".product__accordion_custom details").removeAttr("open");
    //   $(".accordion_pdp_inner .product__accordion_custom").removeClass("hidden_data");
    //   $(".accordion_pdp_inner .product__accordion_custom").removeClass("show_acco");
    //   $(".product__accordion_custom details summary").attr("aria-expanded","false");
    //     $(".accordion_pdp_inner .product__accordion_custom").each(function() {
    //   if($(this).find(".already_selected_message").is(":visible")){
    //      $(this).addClass("hidden_data");
    //   }else{
    //      $(this).addClass("show_acco");
    //     return false;
    //   }
    // });
  
    //     setTimeout(function() {
    //         $(".show_acco details summary").trigger("click");
    //     },100);
    // });
    //     jQuery.getJSON('/cart.js', function(cart) {
    //     for (var i = 0; i < cart.items.length; i++) {
    //     $(".RQ-fdcBlockEach[data-pro-id='"+cart.items[i].id+"']").parents(".product__accordion_custom").find(".already_selected_message").show();
    //     }
  
    //            $(".product__accordion_custom details").removeAttr("open");
    //   $(".accordion_pdp_inner .product__accordion_custom").removeClass("hidden_data");
    //   $(".accordion_pdp_inner .product__accordion_custom").removeClass("show_acco");
    //   $(".product__accordion_custom details summary").attr("aria-expanded","false");
    //     $(".accordion_pdp_inner .product__accordion_custom").each(function() {
    //   if($(this).find(".already_selected_message").is(":visible")){
    //      $(this).addClass("hidden_data");
    //   }else{
    //      $(this).addClass("show_acco");
    //     return false;
    //   }
    // });
  
    //     setTimeout(function() {
    //         $(".show_acco details summary").trigger("click");
    //     },100);
    //   }); 
    $(".ApplyChoosenSort.executionasButton").click(function() {
        setTimeout(function() {
            _swat.initializeActionButtons(".product-grid-container");
        }, 1200);
    });
    $(document).on("change", "select#SortBy", function() {
        setTimeout(function() {
            _swat.initializeActionButtons(".product-grid-container");
        }, 1200);
    });
    $(".collection-page-video").each(function() {
        $(this).find("video")[0].load();
    });
    $(document).on("change", ".new-colection-variants input", function() {
        var variant_id = $(this).attr("var-id");
        var variant_price = $(this).attr("var-price");
        var variant_compareprice = $(this).attr("var-com-price");
        var variant_saleprice = $(this).attr("var-discount");
        var variant_quantity = $(this).attr("var-quantity");
        var variant_policy = $(this).attr("var-policy");
        $(this).parents(".card__content").find(".collProFrm input[name=id]").val(variant_id);
        $(this).parents(".card__content").find(".price__sale span.price-item.price-item--sale.price-item--last").html(variant_price);
        $(this).parents(".card__content").find(".price__sale s.price-item.price-item--regular").html(variant_compareprice);
        $(this).parents(".card__content").find(".PriceWithpercentage span.priceOffer").html(variant_saleprice);
  
        if (variant_quantity == 0 && variant_policy == 'deny') {
            $(this).parents(".card__content").find("span.add_to_cart_text").addClass("hidden");
            $(this).parents(".card__content").find("span.sold-out-message").removeClass("hidden");
            $(this).parents(".card__content").find(".quick-add__submit").attr("aria-disabled", true);
        } else {
            $(this).parents(".card__content").find("span.add_to_cart_text").removeClass("hidden");
            $(this).parents(".card__content").find("span.sold-out-message").addClass("hidden");
            $(this).parents(".card__content").find(".quick-add__submit").removeAttr("aria-disabled");
        }
    });
    $(document).on("change", ".new-colection-variants .INputMnradioBtn input", function() {
        var variant_image = $(this).attr("var-image");
        if ($(window).width() < 990) {
            $(this).parents(".CollProGridItem").find(".fisst_new_image").attr("src", variant_image);
            $(this).parents(".CollProGridItem").find(".fisst_new_image").attr("srcset", variant_image);
        } else {
            $(this).parents(".CollProGridItem").find("img.new-tem-second-image.motion-reduce").attr("src", variant_image);
            $(this).parents(".CollProGridItem").find("img.new-tem-second-image.motion-reduce").attr("srcset", variant_image);
        }
    });
    $(".new-colection-variants .allvarinat_wrapper input").change(function() {
        var var_price = $(this).attr("var-price");
        var var_com_price = $(this).attr("var-com-price");
        if (typeof var_com_price !== 'undefined') {
            $(this).parents(".card-information").find("span.price-item.price-item--sale.price-item--last").html(var_price);
  
            $(this).parents(".card-information").find("s.price-item.price-item--regular").html(var_com_price);
            $(this).parents(".card-information").find("s.price-item.price-item--regular").show();
            $(this).parents(".card-information").find(".PriceWithpercentage").show();
        } else {
            $(this).parents(".card-information").find("span.price-item.price-item--sale.price-item--last").html(var_price);
  
            $(this).parents(".card-information").find("s.price-item.price-item--regular").hide();
            $(this).parents(".card-information").find(".PriceWithpercentage").hide();
  
        }
  
    });
    // Santa Hide Out JS Start
  
    // setInterval(function(){
    //   var date = new Date();
    //   var minutes = 1;
    //   var CurrentLocationPath = window.location.pathname;
    //   date.setTime(date.getTime() + (minutes * 60 * 1000));
    //   let santaLen = parseInt(document.querySelectorAll('.SantaMediaInit').length), RandomSanta = Math.floor(Math.random() * santaLen), CurrentTemplate=document.body.getAttribute('CurrentTemplate')
    //       TemplateNames=['index','page','product'],
    //       RandomTemplate=Math.floor(Math.random() * TemplateNames.length);
    //   TemplateNames.forEach(function(value){
    //     if($.cookie('santa_active') == value){
    //       document.querySelectorAll('[CurrentTemplate="'+value+'"] .SantaMediaInit').forEach(function(evt, key, value){
    //         evt.classList.remove('santa_activenow')
    //       })
    //     }else{
    //       if(typeof $.cookie('santa_active') == 'undefined'){
    //         console.clear()
    //         $.cookie('santa_active',TemplateNames[RandomTemplate], { expires: date })
    //         setTimeout(function(){
    //           console.warn('Santa Is on- '+$.cookie('santa_active')+' Page')
    //           document.querySelectorAll('[CurrentTemplate="'+$.cookie('santa_active')+'"] .SantaMediaInit').forEach(function(evt, key, value){
    //             if(RandomSanta == key){
    //               evt.classList.add('santa_activenow');
    //             }
    //           })
    //         }, 400)
    //       }
    //     }
    //   })
    // },30000)
  
    // Santa Hide Out JS End
  
    var CurrentTemplate = document.body.getAttribute('CurrentTemplate')
    if (CurrentTemplate != 'index') {
        const snowFlakesMN = document.querySelector('.snowFlakesMN');
        if (snowFlakesMN) {
            if (!document.querySelector('.snowFlakesMN').classList.contains('hidden')) {
                setTimeout(function() {
                    document.querySelector('.snowFlakesMN').classList.add('hidden')
                }, 10000)
            }
        }
  
    }
  
  
  
  
  });
  
  $(document).on("click", ".posts_key_points .metafield-rich_text_field ol li", function() {
    var get_handle = $(this).html();
    var data_text3 = get_handle.replace("'", "");
    var finl_get_handle = $.trim(data_text3);
    var header_height = $("div#shopify-section-header").height();
    $('html, body').animate({
        scrollTop: $(".new-article_main-wrapper h2[data-handle='" + finl_get_handle + "']").offset().top - header_height
    }, 2000);
  });
  
  $(document).ready(function() {
    var pincodeHtml = $('.pinncode_adad_btn-wrapper').html();
    if (typeof pincodeHtml !== 'undefined') {
        $.fn.isOnScreen = function() {
  
            var win = $(window);
  
            var viewport = {
                top: win.scrollTop(),
                left: win.scrollLeft()
            };
            viewport.right = viewport.left + win.width();
            viewport.bottom = viewport.top + win.height();
  
            var bounds = this.offset();
            bounds.right = bounds.left + this.outerWidth() + 300;
            bounds.bottom = bounds.top + this.outerHeight() + 300;
  
            return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  
        };
        setTimeout(function() {
            if ($('.pinncode_adad_btn-wrapper').isOnScreen() == true) {
                $(".sticky_bar_bottom").hide();
                $("body").addClass('shift_bottom');
            } else {
                $(".sticky_bar_bottom").show();
                $("body").removeClass('shift_bottom');
            }
        }, 100);
  
        // $(window).scroll(function(){
        // if($('.pinncode_adad_btn-wrapper').isOnScreen() == true ){
        // $(".sticky_bar_bottom").hide();
        // }else{
        // $(".sticky_bar_bottom").show();
        // }
        // });
    }
  });
  $(document).mouseup(function(e) {
    if ($(e.target).closest(".product-media-modal__content").length ===
        0) {
        $(".product-media-modal").removeClass("active");
        $(".product-media-modal").removeAttr("open");
        $("body").removeClass("maskedModal");
    }
  });
  
  
  $(document).on("click", ".cart-page-flat-btn .product-form__submit", function() {
    var flatpro_id = $(this).attr("flatpro-id");
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            id: flatpro_id,
            quantity: 1
        },
        dataType: 'json',
        success: function(gethtml) {
            jQuery.ajax({
                type: 'GET',
                url: gethtml.url,
                dataType: 'json',
                success: function(productdata) {
                    let variant_name = '';
                    for (let i = 0; i < productdata.product.variants.length; i++) {
                        variant_name += productdata.product.variants[i].title + ',';
                    }
                    const new_var_name = variant_name.slice(0, -1).trim();
                    for (let i = 0; i < productdata.product.variants.length; i++) {
                        if (gethtml.variant_title == productdata.product.variants[i].title) {
                            const main_price = parseInt(productdata.product.variants[i].price);
                            const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
                            let discount_exist = 'undefined';
                            if (compare_main_price > main_price) {
                                discount_exist = compare_main_price - main_price;
                            }
                            var variant_string_id = productdata.product.variants[i].id.toString();
                            const itemData = {
                                item_id: productdata.product.variants[i].sku,
                                item_name: gethtml.title,
                                coupon: "undefined",
                                discount: discount_exist,
                                item_brand: productdata.product.vendor,
                                item_category: productdata.product.product_type,
                                item_list_id: "N/A",
                                item_list_name: "N/A",
                                item_variant: new_var_name,
                                price: main_price,
                                quantity: parseInt(get_qty)
                            };
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            window.dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    currency: "INR",
                                    value: productdata.product.variants[i].price,
                                    items: [itemData],
                                },
                            });
  
  
                        }
                    }
  
                },
            });
            jQuery.getJSON('/cart.js', function(cart) {
                const cart_tottal_price = cart.total_price / 100
                var jsonObj = [];
                var requests = cart.items.map(function(item) {
                    return jQuery.ajax({
                        type: 'GET',
                        url: item.url,
                        dataType: 'json'
                    }).then(function(productdata) {
                        var data_category = $(".cart-item[item_id='" + productdata.product.id + "']").attr("data-category");
                        let variant_name = '';
                        for (let i = 0; i < productdata.product.variants.length; i++) {
                            variant_name += productdata.product.variants[i].title + ',';
                        }
                        const new_var_name = variant_name.slice(0, -1).trim();
                        for (let i = 0; i < productdata.product.variants.length; i++) {
                            if (item.variant_title == productdata.product.variants[i].title) {
                                const main_price = parseInt(productdata.product.variants[i].price);
                                const compare_main_price = parseInt(productdata.product.variants[i].compare_at_price);
                                let discount_exist = 'undefined';
                                if (compare_main_price > main_price) {
                                    discount_exist = compare_main_price - main_price;
                                }
                                var variant_string_id = productdata.product.variants[i].id.toString();
  
  
                                return {
                                    item_id: item.id,
                                    item_name: item.title,
                                    coupon: "undefined",
                                    discount: discount_exist,
                                    item_brand: productdata.product.vendor,
                                    item_category: data_category,
                                    item_category2: productdata.product.product_type,
                                    item_list_id: variant_string_id,
                                    item_list_name: productdata.product.variants[i].title,
                                    item_variant: new_var_name,
                                    price: main_price,
                                    quantity: item.quantity
                                };
  
                            }
                        }
  
  
                    });
                });
                jQuery.when.apply(jQuery, requests).done(function() {
                    Array.prototype.forEach.call(arguments, function(result) {
                        jsonObj = jsonObj.concat(result);
                    });
  
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        ecommerce: null
                    }); // Clear the previous ecommerce object.
                    window.dataLayer.push({
                        event: "view_cart",
                        ecommerce: {
                            currency: "INR",
                            value: cart_tottal_price,
                            items: jsonObj,
                        },
                    });
                });
            });
            jQuery.ajax({
                type: 'GET',
                url: '/cart',
                dataType: 'html',
                success: function(cart) {
                    if ($(".UpsellWrapperCard").hasClass("active")) {} else {
                        setTimeout(function() {
                            $(".UpsellWrapperCard").removeClass("active");
                        }, 10);
  
                    }
                    fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                        const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                        const bubble = document.querySelector('#cart-icon-bubble');
                        bubble.innerHTML = bubbleHTML;
                    })
                    fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                        const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                        const drawer = document.querySelector('cart-drawer');
                        drawer.innerHTML = newHTML;
                    });
                    fetch(window.Shopify.routes.root + "?section_id=main-cart-items").then(res => res.text()).then(data => {
                        const cart_page_newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-items').innerHTML;
                        const cart_page = document.querySelector('cart-items');
                        cart_page.innerHTML = cart_page_newHTML;
                    });
                },
            });
        },
    });
  });
  $(document).on("click", "a.mobile_header_search", function(e) {
    e.preventDefault();
    $("body").addClass("SearchBarFocused");
    $(".MobileSearchIconWrapper .mobile_new_search_inner").show();
    $("header.header").addClass("search-bar-active");
    $("body").addClass("desktopSearchBarFocused");
    setTimeout(function() {
        $(".search__input.field__input").focus();
    }, 1200);
  });
  $(document).mouseup(function(e) {
    if ($(e.target).closest("details-modal#header_mobile_search").length ===
        0) {
        $("header.header").removeClass("search-bar-active");
        $("body").removeClass("desktopSearchBarFocused");
    }
  });
  $(document).on("click", "button.search-modal__close-button", function(e) {
    $("body").removeClass("SearchBarFocused");
    $(".MobileSearchIconWrapper .mobile_new_search_inner").hide();
  });
  $(document).on("keyup", "input#Search-In-Modal", function(e) {
    var valuelenght = $(this).val().length;
    if (valuelenght > 0) {
        $(".main_mob_popular_search").hide();
        $(".recent-searched-products").hide();
        $(".GetHtmlOFSearch .newly_pro_heading-wrapp").show();
        $("div#predictive-search-results").show();
  
    } else {
        $(".main_mob_popular_search").show();
        $(".recent-searched-products").show();
        $("div#predictive-search-results").hide();
        $(".GetHtmlOFSearch .newly_pro_heading-wrapp").hide();
    }
  
  });
  
  $(document).on("keyup", "input#Search-In-Modal-1", function(e) {
    var valuelenght = $(this).val().length;
    if (valuelenght > 0) {
        $(".main_desktop_popular_search").hide();
        $(".main_desktop_popular_search .recent-searched-products").hide();
        $(".MainHeaderNavigationCombine .recent-searched-products").hide();
        $(".MainHeaderNavigationCombine .newly_pro_heading-wrapp").hide();
        $("predictive-search.search-modal__form").attr("open", "open");
    } else {
        $(".main_desktop_popular_search").show();
        $(".main_desktop_popular_search .recent-searched-products").show();
        $(".MainHeaderNavigationCombine .recent-searched-products").show();
        $(".MainHeaderNavigationCombine .newly_pro_heading-wrapp").show();
        $("predictive-search.search-modal__form").removeAttr("open", "open");
    }
  
  });
  $(document).on("click", ".bundle_ingradiant_btn", function(e) {
    $("body").addClass("ingrediant_popup_open");
    var data_title = $(this).attr("data-title");
    $(".ingrentPopup[data-title='" + data_title + "']").addClass("ingrediant-popup-active");
  });
  $(document).on("click", ".ingCrossIcon", function(e) {
    $("body").removeClass("ingrediant_popup_open");
    $(".ingrentPopup").removeClass("ingrediant-popup-active");
  });
  
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  }
  
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  $(document).on("click", ".drawer__footer .GiftRewardsWrapper.UpsellWrapperCard .RewardsWithGift.UpsellWithGiftEr", function(e) {
    if ($(this).parents(".GiftRewardsWrapper.UpsellWrapperCard").hasClass("active")) {
        setCookie('accordion_close', 'no', 1);
    } else {
        setCookie('accordion_close', 'yes', 1);
    }
  });
  
  
  $(document).on("change", "input[type=date]", function() {
    var data_value_get = $(this).val();
  
    if (data_value_get !== "") {
        $(this).removeClass("placeholder_shown");
        $(this).addClass("placeholder_hide");
    } else {
        $(this).addClass("placeholder_shown");
        $(this).removeClass("placeholder_hide");
    }
  });
  
  $(document).on("focus", "input[type=date]", function() {
  
    var data_value_get = $(this).val();
    if (data_value_get !== "") {
        $(this).removeClass("placeholder_shown");
        $(this).addClass("placeholder_hide");
    } else {
        $(this).addClass("placeholder_shown");
        $(this).removeClass("placeholder_hide");
    }
  });
  
  
  $(document).on("click", ".iber_additional_info_wrapp li span.copied_text_wrapper strong", function() {
    var temp = document.createElement('input');
    $("span.copied_text_wrapper").removeClass("show_copied_text");
    var texttoCopy = $(this).text();
    var trimed_text = $.trim(texttoCopy);
    var space_removed = trimed_text.replace(" ", "");
    console.log(space_removed);
    temp.type = 'input';
    temp.setAttribute('value', space_removed);
    document.body.appendChild(temp);
    temp.select();
    document.execCommand("copy");
    temp.remove();
    $(this).parents("span.copied_text_wrapper").addClass("show_copied_text");
  });
  $(document).on("click", ".klaviyo-star-rating-widget", function() {
    var header_height = $(".announcement_header-outer-wrapp").height();
    $('html, body').animate({
        scrollTop: $("div#fulfilled-reviews-all").offset().top - header_height
    }, 2000);
  });
  
  
  $(document).on("click", ".icons_and_text-inner-wrapp", function() {
    if ($(window).width() < 750) {
        $("body").addClass("active_tooltip");
        $(".rpeater_inner_images").removeClass("active_tooltip_parent");
        $(this).parents(".rpeater_inner_images").addClass("active_tooltip_parent");
        setTimeout(function() {
            $("body").removeClass("active_tooltip");
            $(".rpeater_inner_images").removeClass("active_tooltip_parent");
        }, 2500);
    }
  });
  
  $(document).mouseup(function(e) {
    if ($("body").hasClass("active_tooltip")) {
        if ($(e.target).closest(".rpeater_inner_images").length ===
            0) {
            $("body").removeClass("active_tooltip");
            $(".rpeater_inner_images").removeClass("active_tooltip_parent");
        }
    }
  });
  window.addEventListener("variant:change", (e) => {
    setTimeout(function() {
        var get_input_val = $(".MainCombineSwatchProductInt .qty_class input.quantity__input").val();
        var data_price = $(".PriceExecutionMnWp .price__container").attr("data-price") * get_input_val,
            final_price = data_price / 1000,
            fixed_price = final_price.toFixed(0);
        $(".pdp_login_text-wrapp .price_append_here").html(fixed_price);
    }, 1200);
  
  });
  $(document).on("click", ".MainCombineSwatchProductInt .qty_class .quantity__button", function() {
    var quanity_value = $(this).parents(".quantity").find("input.quantity__input").val();
    var data_price = $(".PriceExecutionMnWp .price__container").attr("data-price") * quanity_value,
        final_price = data_price / 1000,
        fixed_price = final_price.toFixed(0);
    $(".pdp_login_text-wrapp .price_append_here").html(fixed_price);
  });
  
  
  
  $(document).on("click", ".gift_boxes-plus_icon", function() {
    $("body").addClass("gift_popup_active");
    $(".custom_main_gift-popup").addClass("gift_mainpopup_active");
  });
  $(document).on("click", ".custom-popup-gift_box_inner .gift-popup-cross", function() {
    $("body").removeClass("gift_popup_active");
    $(".custom_main_gift-popup").removeClass("gift_mainpopup_active");
  });
  
  
  var boxgiftid = localStorage.getItem('giftBoxVarid');
  if (boxgiftid) {
    $(".gift_popup-addtocart button").prop("disabled", true);
    $(".gift_popup-addtocart").remove();
  }
  
  $(document).on("click", ".custom_main_gift-popup .gift_popup-addtocart button", function() {
    var productid = $(this).parents(".gift_popup-addtocart").attr("data-varid");
    var $button = $(this); // Store reference to the clicked button 
    localStorage.setItem("giftBoxVarid", productid);
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            id: productid,
            quantity: 1,
        },
        dataType: 'json',
        success: function(productid2) {
            jQuery.ajax({
                type: 'GET',
                url: '/cart',
                dataType: 'html',
                success: function(cart22) {
                    if ($(".UpsellWrapperCard").hasClass("active")) {} else {
                        setTimeout(function() {
                            $(".UpsellWrapperCard").removeClass("active");
                        }, 800);
  
                    }
                    fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                        const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                        const bubble = document.querySelector('#cart-icon-bubble');
                        bubble.innerHTML = bubbleHTML;
                    })
                    fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                        const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                        const drawer = document.querySelector('cart-drawer');
                        drawer.innerHTML = newHTML;
                        var newboxid = localStorage.getItem('giftBoxVarid');
                        if (newboxid) {
                            // Correct way to disable the button
                            $(".gift_popup-addtocart button").prop("disabled", true);
                            // Remove the entire div if needed
                            $(".gift_popup-addtocart").remove();
                        }
                    });
                    $(".RQCartDRawerExecutionmWp ").removeClass("is-empty");
                    $(".RQCartDRawerExecutionmWp ").addClass("active");
                    $("body").removeClass("gift_popup_active");
                    $(".custom_main_gift-popup").removeClass("gift_mainpopup_active");
                    setTimeout(function() {
                        Smile.ready().then(smileInstance => {
                            $(".int_discount_text span.sweettooth-points-balance").html(smileInstance.customer.points_balance);
                        }).catch(err => {
                            // An error has occurred will initializing smile.
                        });
                        if (document.querySelectorAll('.new_custom_drawer_products').length > 0) {
                            function FounderCookie(cookieName) {
                                const cookies = document.cookie.split(';');
                                for (let i = 0; i < cookies.length; i++) {
                                    const cookie = cookies[i].trim();
                                    if (cookie.startsWith(cookieName + '=')) {
                                        return true;
                                    }
                                }
                                return false;
                            }
  
                            function startTimer(duration, display) {
                                var timer = duration,
                                    minutes, seconds;
                                setInterval(function() {
                                    minutes = parseInt(timer / 60, 10)
                                    seconds = parseInt(timer % 60, 10);
                                    // minutes = minutes < 10 ? "0" + minutes : minutes;
                                    // seconds = seconds < 10 ? "0" + seconds : seconds;
  
                                    var minutes_fst = minutes.toString().split("").map(Number)[0];
                                    var minutes_scd = minutes.toString().split("").map(Number)[1];
  
                                    var seconds_fst = seconds.toString().split("").map(Number)[0];
                                    var seconds_scd = seconds.toString().split("").map(Number)[1];
  
                                    if (typeof minutes_scd !== 'undefined') {
                                        display.querySelector('#timer-hours').innerHTML = `<span>${minutes_fst}</span><span>${minutes_scd}</span>`;
                                    } else {
                                        display.querySelector('#timer-hours').innerHTML = `<span>0</span><span>${minutes_fst}</span>`;
                                    }
                                    if (typeof seconds_scd !== 'undefined') {
                                        display.querySelector('#timer-minutes').innerHTML = `<span>${seconds_fst}</span><span>${seconds_scd}</span>`;
                                    } else {
                                        display.querySelector('#timer-minutes').innerHTML = `<span>0</span><span>${seconds_fst}</span>`;
                                    }
                                    if (FounderCookie('offerInvalid')) {} else {
                                        if (--timer < 0) {
                                            const expirationDate = new Date();
                                            expirationDate.setDate(expirationDate.getDate() + 7);
                                            document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
                                        }
                                    }
                                    if (FounderCookie('offerInvalid')) {
                                        if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                                        }
                                        if (document.querySelector('.new_custom_drawer_products')) {
                                            document.querySelector('.new_custom_drawer_products').style.display = 'none';
                                        }
                                        window.localStorage.removeItem("seconds")
                                        window.localStorage.removeItem("minutes")
                                    } else {
                                        if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                            document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                                        }
                                        if (document.querySelector('.new_custom_drawer_products')) {
                                            document.querySelector('.new_custom_drawer_products').style.display = 'block';
                                        }
                                        window.localStorage.setItem("seconds", seconds)
                                        window.localStorage.setItem("minutes", minutes)
                                    }
                                }, 1000);
                            }
                            var sec = parseInt(window.localStorage.getItem("seconds"));
                            var min = parseInt(window.localStorage.getItem("minutes"));
  
                            if (FounderCookie('offerInvalid')) {
                                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                                }
                                if (document.querySelector('.new_custom_drawer_products')) {
                                    document.querySelector('.new_custom_drawer_products').style.display = 'none';
                                }
                                window.localStorage.removeItem("seconds")
                                window.localStorage.removeItem("minutes")
                            } else {
                                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'block';
                                }
                                if (document.querySelector('.new_custom_drawer_products')) {
                                    document.querySelector('.new_custom_drawer_products').style.display = 'block';
                                }
                            }
  
                            if (parseInt(min * sec)) {
                                var fiveMinutes = (parseInt(min * 60) + sec);
                            } else {
                                var fiveMinutes = 60 * 30;
                            }
  
                            var display = document.querySelector('#timer-box');
                            if (parseInt(min) == 0) {
                                if (document.querySelector('.drawer_timer_outer-wrapp')) {
                                    document.querySelector('.drawer_timer_outer-wrapp').style.display = 'none';
                                }
                                if (document.querySelector('.new_custom_drawer_products')) {
                                    document.querySelector('.new_custom_drawer_products').style.display = 'none';
                                }
                                window.localStorage.removeItem("seconds")
                                window.localStorage.removeItem("minutes")
                                const expirationDate = new Date();
                                expirationDate.setDate(expirationDate.getDate() + 7);
                                document.cookie = `offerInvalid=true; expires=${expirationDate.toUTCString()}; path=/`;
                            } else {
                                startTimer(fiveMinutes, display);
                            }
  
                        } else {
                            document.querySelector('.drawer_timer_outer-wrapp').classList.add('hidden');
                        }
                    }, 800);
                },
            });
        },
    });
  });
  $(document).on("click", ".tick_icon_added-text", function() {
    localStorage.removeItem("giftBoxVarid");
    var Obj = $(this).attr("data-varid");
  
    //alert(Obj);
    let updates = {
        [Obj]: 0
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates
            })
        })
        .then(response => {
            return response.json();
        }).then(results => {
            $.ajax({
                type: 'GET',
                url: '/',
                dataType: 'html',
                success: function(html_get) {
                    if ($(".UpsellWrapperCard").hasClass("active")) {} else {
                        setTimeout(function() {
                            $(".UpsellWrapperCard").removeClass("active");
                        }, 800);
  
                    }
                    fetch(window.Shopify.routes.root + "?section_id=cart-icon-bubble").then(request => request.text()).then(response => {
                        const bubbleHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                        const bubble = document.querySelector('#cart-icon-bubble');
                        bubble.innerHTML = bubbleHTML;
                    })
                    fetch(window.Shopify.routes.root + "?section_id=cart-drawer").then(res => res.text()).then(data => {
                        const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer').innerHTML;
                        const drawer = document.querySelector('cart-drawer');
                        drawer.innerHTML = newHTML;
                    });
                    $(".RQCartDRawerExecutionmWp ").removeClass("is-empty");
                    $(".RQCartDRawerExecutionmWp ").addClass("active");
                    $("body").removeClass("gift_popup_active");
                    $(".custom_main_gift-popup").removeClass("gift_mainpopup_active");
                    setTimeout(function() {
                        Smile.ready().then(smileInstance => {
                            $(".int_discount_text span.sweettooth-points-balance").html(smileInstance.customer.points_balance);
                        }).catch(err => {
                            // An error has occurred will initializing smile.
                        });
                    }, 800);
                },
            });
        })
        .catch((error) => {
            console.error('Error:', error);
        });
  });
  
  
  // document.addEventListener('DOMContentLoaded', function() {
  //   const listItems = document.querySelectorAll('.higligted_text-outer-wrap .higligted-inner-rpeater');
  
  //   listItems.forEach(function(item) {
  //     item.addEventListener('click', function() {
  //       // Remove the 'active' class from all list items
  //       listItems.forEach(function(i) {
  //         i.classList.remove('active');
  //       });
  
  //       // Add the 'active' class to the clicked list item
  //       item.classList.add('active');
  //     });
  //   });
  // });